;
define("facets_items_collection_view_row.tpl", function(){});

